import {Injectable} from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class StaffService {

    constructor(private commonService: CommonService) {
    }

    async getStaffMembers() {
        try {
            const staffRequest = await this.commonService.getList('staff');
            return staffRequest.object;
        } catch (e) {
            throw e;
        }
    }

    async updateStaffRole(relation: any) {
        try {
            await this.commonService.insertItem('staff/updateRole', relation);
        } catch (e) {
            throw e;
        }
    }

    async updateMemberLevels(levels, userId) {
        try {
            await this.commonService.insertItem('staff/updateLevels', {levels, userId});
        } catch (e) {
            throw e;
        }
    }

    async updateMemberUnits(units, userId) {
        try {
            await this.commonService.insertItem('staff/updateUnits', {units, userId});
        } catch (e) {
            throw e;
        }
    }
}
